module.exports = __webpack_public_path__ + "resources/img/img_ssl_ceritificate1.644904b0d7dedc0382bcc8e808427b72.png";